import { SET_USER_PLANT, SET_USER_DETAIL, SET_PLANT_HOST, DRAW_RECORD_DATA } from './types';

export default {
    [SET_USER_PLANT](state, params) {
        const { newUserHeart = {} } = params.data;
        if (newUserHeart.enabled) {
            newUserHeart.production = newUserHeart.production.map((item) => {
                return {
                    value: item,
                };
            });
        }
        Object.assign(state.userPlantData, params.data);
    },
    [SET_USER_DETAIL](state, params) {
        Object.assign(state.userDetail, params.data);
    },
    [SET_PLANT_HOST](state, payload) {
        state.host = payload.data;
    },
    [DRAW_RECORD_DATA](state, payload) {
        state.drawRecordData = payload.data;
    },
};
